// utils/menuUtils.js
export const buildMenuTree = (routes = []) => {
    const map = {};
    routes.forEach((item) => {
      if (!map[item.parentPageId]) map[item.parentPageId] = [];
      map[item.parentPageId].push(item);
    });
  
    Object.keys(map).forEach((key) => {
      map[key].sort((a, b) => a.order - b.order);
    });
  
    const buildTree = (nodes) =>
      nodes.map((node) => ({
        ...node,
        children: map[node.pageId] ? buildTree(map[node.pageId]) : [],
      }));
  
    return buildTree(map[0] || []);
  };
  